/* eslint-disable no-unused-vars, eqeqeq */
import { useState, useEffect, Fragment, useRef } from "react";
import dayjs from "dayjs";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import IconButton from "@mui/material/IconButton";
import MuiInput from "@mui/material/Input";
import { styled } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import Dropdown from "@mui/joy/Dropdown";
import MenuButton from "@mui/joy/MenuButton";
import MoreVert from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
// import jwt from "jsonwebtoken";
import { jwtDecode } from "jwt-decode";
import SpdGraph from "./SpdGraph";

import {
  getRooms,
  getSpectrum,
  updateSpectrum,
  getAllSpectrum,
  getSpectrumByRoomId,
  createRoutine,
  createSpectrum,
  updateSpectrumRoom,
  getAllSpectrumByRoomId,
} from "../service/service_handler";

const Input = styled(MuiInput)`
  width: 42px;
`;

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(0.5),
    border: 0,
    "&.Mui-disabled": {
      border: 0,
      color: "primary",
    },
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
  background: "primry",
}));

const spectrum_controls = [
  {
    channelName: "Green",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Red",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Yellow",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Blue",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Pink",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Orange",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Channel",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Dummy 1",
    channelValue: 10,
    isActive: true,
  },
  {
    channelName: "Dummy 2",
    channelValue: 10,
    isActive: true,
  },
];

const channelOptions = [
  { name: "3000K WHITE", color: "#FACC15" },
  { name: "4000K WHITE", color: "#FACC15" },
  { name: "5700K WHITE", color: "#FACC15" },
  { name: "6500K WHITE", color: "#FACC15" },
  { name: "395NM UV", color: "#8B5CF6" },
  { name: "450NM BLUE", color: "#3B82F6" },
  { name: "520NM GREEN", color: "#22C55E" },
  { name: "630NM RED", color: "#EF4444" },
  { name: "660NM DEEP RED", color: "#EF4444" },
  { name: "735NM HYPER RED", color: "#EC4899" },
];

const channelColorMap = channelOptions.reduce((acc, option) => {
  acc[option.name] = option.color;
  return acc;
}, {});

export default function AdminSpectrum() {
  const [open, setOpen] = useState(false);
  const [weekNames, setWeekNames] = useState("");
  const [activeRoom, setActiveRoom] = useState({});
  const [roomNames, setRoomNames] = useState([]);
  const [roomName, setRoomName] = useState("");
  const [roomDetails, setRoomDetails] = useState({});
  const [weeks, setWeeks] = useState(() => []);
  const [value, setValue] = useState([]);
  const [spectrum, setSpectrum] = useState(() => []);
  const [openSnack, setOpenSnack] = useState(false);
  const [openSnackErrMsg, setopenSnackErrMsg] = useState("");
  const [exisingSchedule, setExisingSchedule] = useState("");
  const [checked, setChecked] = useState(true);
  const weeksName = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const [isVisible, setIsVisible] = useState(false);
  const [lockRatio, setLockRatio] = useState(false);
  const [openSpectrum, setOpenSpectrum] = useState(false);
  const [routineNameInput, setRoutineNameInput] = useState("");
  const [routineAction, setRoutineAction] = useState("ON");
  const [routineTime, setRoutineTime] = useState(dayjs(new Date().getTime()));
  const [noRoomData, setNoRoomData] = useState(false);
  const [noSpectrumData, setNoSpectrumData] = useState(false);
  const [spectrumName, setSpectrumName] = useState("");
  const [spectrumNames, setSpectrumNames] = useState([]);
  const [spectrumNameAct, setSpectrumNameAct] = useState({});
  const [noData, setNoData] = useState(false);
  const [roles, setRoles] = useState([]);
  const weekDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const [weekValues, setWeekValues] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [spectrumNameRot, setSpectrumNameRot] = useState("");
  const [spectrumNamesRot, setSpectrumNamesRot] = useState([]);
  const [roomNameRot, setRoomNameRot] = useState("");
  const [spectrumNameText, setSpectrumNameText] = useState("");

  useEffect(() => {
    if (localStorage.getItem("token")) {
      setRoles(jwtDecode(localStorage.getItem("token")).roles);
      console.log(
        "roles: " + JSON.stringify(jwtDecode(localStorage.getItem("token")))
      );
    }
    // getSpectrumByRoomId()
    //   .then(function (response) {
    //     // setSpectrumNames(response.data.spectrums);
    //     setSpectrumNameAct(response.data.spectrums[0]);
    //     setRoomDetails(response.data.spectrums[0].room);
    //     setRoomName(response.data.spectrums[0].room.roomName);
    //     setSpectrum(response.data.spectrums[0].channelData);
    //     setLockRatio(response.data.spectrums[0].lockRatio);
    //   })
    //   .catch((error) => {
    //     console.log("service-error", error);
    //     if (!error.response) {
    //       setopenSnackErrMsg("Network error please try again");
    //       setOpenSnack(true);
    //       setNoData(true);
    //     } else {
    //       setopenSnackErrMsg(
    //         error.response.data.code + " - Please try again later"
    //       );
    //       setOpenSnack(true);
    //       setNoData(true);
    //     }
    //   });

    getAllSpectrumByRoomId()
      .then(function (response) {
        console.log(
          "spectrum-names: " + JSON.stringify(response.data.spectrums)
        );
        setSpectrumNames(response.data.spectrums);
        setSpectrumNameAct(response.data.spectrums[0]);
        // setRoomDetails(response.data.spectrums[0].room);
        // setRoomName(response.data.spectrums[0].room.roomName);
        setSpectrum(response.data.spectrums[0].channelData);
        setLockRatio(response.data.spectrums[0].lockRatio);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Networkk error please try again");
          setOpenSnack(true);
          setNoData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
          setNoData(true);
        }
      });
  }, []);

  const handleRoomChange = (e, val) => {
    console.log("toggle-val:" + val.spectrumControlId);
    getSpectrumByRoomId(val.roomId)
      .then(function (response) {
        // setSpectrumNames(response.data.spectrums);
        setSpectrumNameAct(response.data.spectrums[0]);
        setRoomDetails(response.data.spectrums[0].room);
        setRoomName(response.data.spectrums[0].room.roomName);
        setSpectrum(response.data.spectrums[0].channelData);
        setLockRatio(response.data.spectrums[0].lockRatio);
        setActiveRoom(val);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("No Data found");
          setOpenSnack(true);
          setNoData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
          setNoData(true);
        }
      });

    getAllSpectrumByRoomId(val.roomId)
      .then(function (response) {
        setSpectrumNames(response.data.spectrums);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
          setNoData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
          setNoData(true);
        }
      });

    // console.log("spectrum service" + response.data.spectrum);
    // setRoomDetails(response.data.spectrum);
    // setRoomName(response.data.spectrum.room.roomName);
    // setSpectrum(response.data.spectrum.channelData);
    // setLockRatio(response.data.spectrum.lockRatio);
    // setActiveRoom(val);
  };

  const handleWeeks = (e, val) => {
    console.log("week-name:" + val);
    setWeeks(val);
  };

  const handleClickOpen = () => {
    setOpen(true);
    setIsVisible(false);
  };

  const handleSpectrumOpen = () => {
    console.log("spectrum " + JSON.stringify(spectrumNameAct));
    setOpenSpectrum(true);
    setIsVisible(false);
  };

  const handleClose = () => {
    setOpen(false);
    // setIsVisible(false);
    // !open ? setIsVisible(false) : setIsVisible(false);
  };

  const handleCloseRoutines = () => {
    setRoutineTime(dayjs(new Date()));
    setRoutineNameInput("");
    setRoutineAction(1);
    setRoomNameRot("");
    setSpectrumNameRot("");
    setWeekValues([0, 0, 0, 0, 0, 0, 0]);
    setOpen(!open);
  };

  const handleSpectrumClose = () => {
    setSpectrumNameText("");
    setOpenSpectrum(false);
    // !openSpectrum ? setIsVisible(false) : setIsVisible(false);
  };

  const handleChange = (event) => {
    setSpectrumNameAct(event.target.value);
  };

  const parseSliderTargetValue = (e, explicitValue) => {
    if (typeof explicitValue === "number" && Number.isFinite(explicitValue)) {
      return explicitValue;
    }
    const raw = e?.target?.value;
    if (raw === undefined || raw === null || raw === "") {
      return null;
    }
    const n = typeof raw === "number" ? raw : parseFloat(String(raw));
    return Number.isFinite(n) ? n : null;
  };

  const mergeAdminSpectrumChannelValues = (prev, newValue, channelIndex) => {
    if (!lockRatio) {
      return prev.map((ch, i) =>
        i === channelIndex ? { ...ch, channelValue: newValue } : ch
      );
    }

    const master = Number(prev[channelIndex]?.channelValue);
    const masterOk = Number.isFinite(master) && master !== 0;
    const ratios = prev.map((v, indexChange) => {
      if (!v.isActive) {
        return v.channelValue;
      }
      if (indexChange === channelIndex) {
        return 1;
      }
      if (!masterOk) {
        return 1;
      }
      const q = Number(v.channelValue) / master;
      return Number.isFinite(q) ? q : 1;
    });
    return prev.map((ch, i) => {
      if (!ch.isActive) {
        return ch;
      }
      const r = ratios[i];
      const factor =
        typeof r === "number" && Number.isFinite(r) ? r : 1;
      return { ...ch, channelValue: newValue * factor };
    });
  };

  const persistAdminSpectrumNow = (channelDataArray) => {
    if (!spectrumNameAct?.spectrumControlId) {
      return;
    }
    const updateSpectrumData = {
      channelData: JSON.stringify(channelDataArray),
      lockRatio: lockRatio,
      roomId: spectrumNameAct.roomId,
    };

    updateSpectrum(spectrumNameAct.spectrumControlId, updateSpectrumData)
      .then(function (response) {
        console.log("update spectrum" + response.data.code);
        if (response.data.code === "SPECTRUM_UPDATE_FAIL") {
          setopenSnackErrMsg("Failed to update Spectrum Data");
          setOpenSnack(true);
        } else {
          setopenSnackErrMsg("Successfully updated spectrum data");
          setOpenSnack(true);
        }
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
        }
      });
  };

  const handleSliderChange = (e, channelIndex, explicitValue, meta) => {
    if (!roles.includes("edit-spectrum")) {
      return;
    }
    const newValue = parseSliderTargetValue(e, explicitValue);
    if (newValue === null) {
      return;
    }

    let nextSnapshot = null;
    setSpectrum((prev) => {
      nextSnapshot = mergeAdminSpectrumChannelValues(
        prev,
        newValue,
        channelIndex
      );
      return nextSnapshot;
    });

    if (meta?.fromArrow && nextSnapshot) {
      persistAdminSpectrumNow(nextSnapshot);
    }
  };

  const handleInputChange = (event, channelIndex) => {
    if (!roles.includes("edit-spectrum")) {
      return;
    }
    const newValue = parseFloat(String(event?.target?.value ?? ""));
    if (!Number.isFinite(newValue)) {
      return;
    }

    setSpectrum((prev) =>
      mergeAdminSpectrumChannelValues(prev, newValue, channelIndex)
    );
  };

  const changeSliderState = (event, index) => {
    if (roles.includes("edit-spectrum")) {
      const updateSpectrumData = {
        channelData: JSON.stringify(spectrum),
        lockRatio: lockRatio,
        roomId: roomDetails.roomId,
      };
      // console.log("updateSpectrumData: ")
      updateSpectrum(roomDetails.roomId, updateSpectrumData)
        .then(function (response) {
          console.log("update spectrum" + response.data.code);
          if (response.data.code === "SPECTRUM_UPDATE_FAIL") {
            setopenSnackErrMsg("Failed to update Spectrum Data");
            setOpenSnack(true);
          } else {
            setopenSnackErrMsg("Successfully updated spectrum data");
            setOpenSnack(true);
          }
        })
        .catch((error) => {
          console.log("service-error", error);
          if (!error.response) {
            setopenSnackErrMsg("Network error please try again");
            setOpenSnack(true);
          } else {
            setopenSnackErrMsg(
              error.response.data.code + " - Please try again later"
            );
            setOpenSnack(true);
          }
        });

      setSpectrum((prevValues) => {
        const newValues = [...prevValues];
        newValues[index].isActive = !newValues[index].isActive;
        newValues[index].channelValue = 1;
        return newValues;
      });
    }
  };

  const handleBlur = () => {
    if (value < 0) {
      setValue(0);
    } else if (value > 100) {
      setValue(100);
    }
  };

  const saveSpectrumAfterChange = (newSpectrum) => {
    if (!spectrumNameAct?.spectrumControlId) return;
    const updateSpectrumData = {
      channelData: JSON.stringify(newSpectrum),
      lockRatio: lockRatio,
      roomId: spectrumNameAct.roomId,
    };
    updateSpectrum(spectrumNameAct.spectrumControlId, updateSpectrumData)
      .then(function (response) {
        if (response.data.code === "SPECTRUM_UPDATE_FAIL") {
          setopenSnackErrMsg("Failed to update Spectrum Data");
          setOpenSnack(true);
        } else {
          setopenSnackErrMsg("Successfully updated spectrum data");
          setOpenSnack(true);
        }
      })
      .catch((error) => {
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
        }
      });
  };

  const handleAddSlider = () => {
    if (roles.includes("edit-spectrum") && spectrumNameAct?.spectrumControlId) {
      const nextIndex = spectrum.findIndex((v) => !v.isActive);
      if (nextIndex === -1) return;
      const newSpectrum = spectrum.map((v, i) =>
        i === nextIndex
          ? { ...v, isActive: true, channelValue: v.channelValue || 1 }
          : v
      );
      setSpectrum(newSpectrum);
      saveSpectrumAfterChange(newSpectrum);
    }
  };

  const handleChannelNameChange = (event, index) => {
    if (roles.includes("edit-spectrum") && spectrumNameAct?.spectrumControlId) {
      const newName = event.target.value;
      const newSpectrum = spectrum.map((v, i) =>
        i === index ? { ...v, channelName: newName } : v
      );
      setSpectrum(newSpectrum);
      saveSpectrumAfterChange(newSpectrum);
    }
  };

  const handleRemoveSlider = (index) => {
    if (roles.includes("edit-spectrum") && spectrumNameAct?.spectrumControlId) {
      const newSpectrum = spectrum.map((v, i) =>
        i === index ? { ...v, isActive: false, channelName: "" } : v
      );
      setSpectrum(newSpectrum);
      saveSpectrumAfterChange(newSpectrum);
    }
  };

  const handleChangeComplete = () => {
    console.log("Change event completed");
    persistAdminSpectrumNow(spectrum);
  };

  const handleClick = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  const showAddOptions = () => {
    setIsVisible(!isVisible);
  };

  const changeRatioState = () => {
    if (roles.includes("edit-spectrum")) {
      console.log(lockRatio);
      const updateSpectrumData = {
        channelData: JSON.stringify(spectrum),
        lockRatio: !lockRatio,
        roomId: spectrumNameAct.roomId,
      };

      updateSpectrum(spectrumNameAct.spectrumControlId, updateSpectrumData)
        .then(function (response) {
          console.log("update spectrum" + response.data.code);
          if (response.data.code === "SPECTRUM_UPDATE_FAIL") {
            setopenSnackErrMsg("Failed to update Spectrum Data");
            setOpenSnack(true);
          } else {
            setLockRatio(!lockRatio);
            setopenSnackErrMsg("Successfully updated spectrum data");
            setOpenSnack(true);
          }
        })
        .catch((error) => {
          console.log("service-error", error);
          if (!error.response) {
            setopenSnackErrMsg("Network error please try again");
            setOpenSnack(true);
          } else {
            setopenSnackErrMsg(
              error.response.data.code + " - Please try again later"
            );
            setOpenSnack(true);
          }
        });
    }
  };

  const handleActionChange = (event, action) => {
    setRoutineAction(action);
  };

  const handleRoutineNameChange = (event) => {
    setRoutineNameInput(event.target.value);
  };

  const handleSave = () => {
    console.log(routineNameInput);
    console.log(routineTime);
    console.log(routineAction);
    console.log(roomName);
    console.log(spectrumName);

    setOpen(!open);
  };

  const handleSpectrumChange = (event) => {
    setSpectrumNameRot(event.target.value);
  };

  const handleWeekCheckbox = (event, index) => {
    setWeekValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[index] = 1;
      return newValues;
    });
    console.log(weekValues);
  };

  const handleSaveRoutines = () => {
    var utc = require("dayjs/plugin/utc");
    dayjs.extend(utc);
    // console.log(dayjs.utc().format());
    console.log("name" + routineNameInput);
    // console.log(dayjs.utc(routineTime).format().split("T")[1].split("Z")[0]);
    // console.log("rot: " + routineTime);
    // console.log(routineAction);
    console.log(roomName);
    console.log(spectrumName);
    // console.log(weekValues);
    if (routineNameInput != "" && roomNameRot && spectrumNameRot) {
      const routine_data = {
        routineName: routineNameInput,
        action: parseInt(routineAction),
        daysInWeek: weekValues.toString(),
        spectrumId: spectrumName.spectrumId,
        spectrumName: spectrumName.spectrumName,
        actionTime: dayjs.utc(routineTime).format().split("T")[1].split("Z")[0],
        roomId: roomName.roomId,
      };
      createRoutine(routine_data)
        .then(function (response) {
          setOpen(!open);
          setopenSnackErrMsg("Successfully Created routine");
          setOpenSnack(true);
        })
        .catch((error) => {
          console.log("service-error", error);
          if (!error.response) {
            setopenSnackErrMsg("Network error please try again");
            setOpenSnack(true);
            setNoData(true);
          } else {
            setopenSnackErrMsg(
              error.response.data.code + " - Please try again later"
            );
            setOpenSnack(true);
            setNoData(true);
          }
        });
    } else {
      setopenSnackErrMsg("Please enter valid data to continue");
      setOpenSnack(true);
    }
  };

  const handleRoomChangeRoutine = (event) => {
    getAllSpectrumByRoomId(event.target.value.roomId)
      .then(function (response) {
        console.log(response.data.spectrums);
        setRoomNameRot(event.target.value);
        setSpectrumNamesRot(response.data.spectrums);
        setSpectrumNameRot(response.data.spectrums[0]);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
          noSpectrumData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
          setNoSpectrumData(true);
        }
      });
  };

  const handleNewSpectrum = () => {
    const spectrum_data = {
      roomId: roomDetails.roomId,
      lockRatio: 0,
      spectrumName: spectrumNameText,
      spectrumControl: JSON.stringify(spectrum),
    };

    createSpectrum(undefined, spectrum_data)
      .then(function (response) {
        setOpenSpectrum(false);
        setopenSnackErrMsg("Successfully created Spectrum ");
        setOpenSnack(true);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
          setNoData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.message + " - Please try again later"
          );
          setOpenSnack(true);
          setNoData(true);
        }
      });
  };

  const handleUpdateSpectrum = () => {
    const spectrum_data = {
      roomId: roomDetails.roomId,
      spectrumControlId: spectrumNameAct.spectrumControlId,
    };
    updateSpectrumRoom(roomDetails.roomId, spectrum_data)
      .then(function (response) {
        setOpenSpectrum(false);
        setopenSnackErrMsg("Successfully updated Spectrum ");
        setOpenSnack(true);
      })
      .catch((error) => {
        console.log("service-error", error);
        if (!error.response) {
          setopenSnackErrMsg("Network error please try again");
          setOpenSnack(true);
          setNoData(true);
        } else {
          setopenSnackErrMsg(
            error.response.data.code + " - Please try again later"
          );
          setOpenSnack(true);
          setNoData(true);
        }
      });
  };

  const handleSpectrumNameText = (event) => {
    setSpectrumNameText(event.target.value);
  };

  const snackAction = (
    <Fragment>
      {/* <Button color="secondary" size="small" onClick={handleCloseSnack}>
        UNDO
      </Button> */}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnack}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  return (
    <Box sx={{ width: "100%", minWidth: 0 }}>
      <Typography
        sx={{ mb: 1.5, fontWeight: "bold", color: "text.primary", fontSize: { xs: "1.1rem", sm: "1.25rem" } }}
        variant="h5"
        component="div"
      >
        Admin Spectrum
      </Typography>
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleCloseSnack}
        message={openSnackErrMsg}
        action={snackAction}
      />

      <Dialog open={openSpectrum} onClose={handleSpectrumClose}>
        <DialogTitle sx={{ ml: 1, mt: 1 }}>Manage Spectrum</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleSpectrumClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {!isVisible && (
            <div>
              <Box sx={{ minWidth: 350, mt: 2 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Choose Spectrum
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={spectrumNameAct}
                    label="Choose Schedule"
                    onChange={handleChange}
                  >
                    {noData ? (
                      <em>
                        <MenuItem value="NaNa">No Data Found</MenuItem>
                      </em>
                    ) : (
                      spectrumNames.map((spectrumValue, index) =>
                        spectrumValue.status == 1 ? (
                          <MenuItem value={spectrumValue}>
                            {spectrumValue.spectrumName}{" "}
                            <em>&nbsp;(Active) </em>
                          </MenuItem>
                        ) : (
                          <MenuItem value={spectrumValue}>
                            {spectrumValue.spectrumName}
                          </MenuItem>
                        )
                      )
                    )}
                  </Select>
                </FormControl>
              </Box>
              <Typography id="input-slider" align="center" sx={{ m: 1 }}>
                Or
              </Typography>
              <Box textAlign="center" mb={3}>
                <Button
                  variant="contained"
                  size="small"
                  position="relative"
                  align="center"
                  justifyContent="center"
                  onClick={showAddOptions}
                >
                  <AddIcon />
                  &nbsp;New Spectrum
                </Button>
              </Box>
            </div>
          )}

          {isVisible && (
            <div>
              <TextField
                autoFocus
                margin="dense"
                size="small"
                id="spectrum_name"
                label="Spectrum Name"
                type="spectrum_name"
                sx={{ width: 350 }}
                variant="outlined"
                value={spectrumNameText}
                onChange={handleSpectrumNameText}
              />
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 1, md: 1 }}
                mt={0.5}
              >
                <Grid item xs={6}></Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={6}></Grid>
              </Grid>
            </div>
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1, mr: 1 }}>
          <Button onClick={handleSpectrumClose}>Cancel</Button>
          {isVisible ? (
            <Button onClick={handleNewSpectrum}>Save</Button>
          ) : (
            <Button onClick={handleUpdateSpectrum}>Update</Button>
          )}
        </DialogActions>
      </Dialog>

      <Box>
        <Paper elevation={2} sx={{ pr: 6, pl: 6, pb: 6, pt: 3 }}>
          <Stack
            direction="row"
            spacing={2}
            mb={3}
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography sx={{ mb: 2 }} variant="h6">
              {roomName}
            </Typography>

            <Stack
              direction="row"
              spacing={2}
              mb={2}
              justifyContent="flex-end"
              alignItems="center"
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox checked={lockRatio} onClick={changeRatioState} />
                  }
                  label="Set Ratio"
                />
              </FormGroup>
              <Button
                variant="contained"
                size="small"
                onClick={handleSpectrumOpen}
                disabled={!roles.includes("add-spectrum")}
              >
                <SaveAsIcon />
                &nbsp;Spectrum
              </Button>
            </Stack>
          </Stack>

          {spectrumNameAct?.spectrumName === "Spectrum Off" ? (
            <Box sx={{ py: 2, px: 1, textAlign: "center", width: "100%" }}>
              <Typography variant="body2" color="text.secondary">
                All wavelengths Set to OFF
              </Typography>
            </Box>
          ) : (
          <>
          <Grid
            container
            spacing={{ xs: 0.35, md: 0.35 }}
            columns={{ xs: 4, sm: 4, md: 4 }}
            sx={{ flex: 1, alignContent: "flex-start" }}
          >
            {spectrum
              .map((value, index) => ({ value, index }))
              .filter(({ value }) => value.isActive)
              .map(({ value, index }) => (
                <Grid item xs={4} sm={4} md={4} key={index}>
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "100%",
                      mx: "auto",
                      px: 0.1,
                      py: 0.1,
                      position: "relative",
                      "&:hover .slider-close": { opacity: 1 },
                    }}
                  >
                    <Paper elevation={2} className="slider-tile" sx={{ p: 0.4, borderRadius: 0.5 }}>
                      {index !== 0 && (
                        <IconButton
                          className="slider-close"
                          size="small"
                          onClick={() => handleRemoveSlider(index)}
                          sx={{
                            position: "absolute",
                            top: -10,
                            right: -10,
                            opacity: 0,
                            transition: "opacity 0.2s ease",
                            bgcolor: "rgba(255, 255, 255, 0.9)",
                            boxShadow: "0 4px 10px rgba(15, 23, 42, 0.18)",
                            "&:hover": { bgcolor: "rgba(255, 255, 255, 1)" },
                            width: 18,
                            height: 18,
                          }}
                        >
                          <CloseIcon sx={{ fontSize: 10 }} />
                        </IconButton>
                      )}
                      <Stack
                        direction="row"
                        spacing={0.5}
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <FormControl size="small">
                          <Select
                            value={
                              channelColorMap[value.channelName]
                                ? value.channelName
                                : ""
                            }
                            displayEmpty
                            onChange={(event) =>
                              handleChannelNameChange(event, index)
                            }
                            renderValue={(selected) =>
                              selected ? (
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: 10,
                                    fontWeight: 700,
                                    color: "#0B0F1A",
                                  }}
                                >
                                  {selected}
                                </Typography>
                              ) : (
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{ fontSize: 10 }}
                                >
                                  Select name
                                </Typography>
                              )
                            }
                            sx={{
                              minWidth: 96,
                              "& .MuiSelect-icon": { opacity: 0 },
                              "&:hover .MuiSelect-icon": { opacity: 1 },
                              "& .MuiSelect-select": {
                                display: "flex",
                                alignItems: "center",
                                fontSize: 10,
                                py: 0.25,
                              },
                            }}
                          >
                            {channelOptions.map((option) => {
                              const isTaken =
                                spectrum.some(
                                  (item) =>
                                    item.isActive &&
                                    item.channelName === option.name
                                ) && option.name !== value.channelName;
                              return (
                                <MenuItem
                                  key={option.name}
                                  value={option.name}
                                  disabled={isTaken}
                                >
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                  >
                                    <Box
                                      sx={{
                                        width: 9,
                                        height: 9,
                                        borderRadius: "50%",
                                        bgcolor: option.color,
                                      }}
                                    />
                                    <Typography variant="body2" sx={{ fontSize: 12 }}>
                                      {option.name}
                                    </Typography>
                                  </Stack>
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                        <Stack
                          direction="column"
                          spacing={0}
                          alignItems="center"
                          sx={{
                            transition: "opacity 0.2s ease",
                            "@media (hover: none)": {
                              opacity: 1,
                              pointerEvents: "auto",
                            },
                            "@media (hover: hover)": {
                              opacity: 0,
                              pointerEvents: "none",
                              ".slider-tile:hover &": {
                                opacity: 1,
                                pointerEvents: "auto",
                              },
                            },
                          }}
                        >
                          <IconButton
                            type="button"
                            size="small"
                            onMouseDown={(ev) => {
                              ev.preventDefault();
                              ev.stopPropagation();
                            }}
                            onClick={(ev) => {
                              ev.preventDefault();
                              ev.stopPropagation();
                              const cur = Number(value.channelValue);
                              const base = Number.isFinite(cur) ? cur : 0;
                              handleSliderChange(
                                null,
                                index,
                                Math.min(100, base + 1),
                                { fromArrow: true }
                              );
                            }}
                            sx={{ width: 28, height: 22, p: 0, minWidth: 28 }}
                          >
                            <KeyboardArrowUpIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                          <IconButton
                            type="button"
                            size="small"
                            onMouseDown={(ev) => {
                              ev.preventDefault();
                              ev.stopPropagation();
                            }}
                            onClick={(ev) => {
                              ev.preventDefault();
                              ev.stopPropagation();
                              const cur = Number(value.channelValue);
                              const base = Number.isFinite(cur) ? cur : 0;
                              handleSliderChange(
                                null,
                                index,
                                Math.max(0, base - 1),
                                { fromArrow: true }
                              );
                            }}
                            sx={{ width: 28, height: 22, p: 0, minWidth: 28 }}
                          >
                            <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Stack>
                        <Box
                          sx={{
                            minWidth: 44,
                            textAlign: "right",
                            fontSize: 14,
                            fontWeight: 700,
                            pr: 0.5,
                            mr: 1,
                          }}
                        >
                          {value.channelValue >= 100
                            ? 100
                            : Math.round(value.channelValue)}
                          <Box component="span" sx={{ ml: 0.2 }}>
                            %
                          </Box>
                        </Box>
                      </Stack>

                      <Grid
                        container
                        spacing={0.5}
                        alignItems="center"
                        sx={{ px: 1 }}
                      >
                        <Grid item xs>
                          <Slider
                            size="small"
                            step={1}
                            min={0}
                            max={100}
                            value={(() => {
                              const n = Number(value.channelValue);
                              if (!Number.isFinite(n)) {
                                return 0;
                              }
                              return n >= 100 ? 100 : Math.round(n);
                            })()}
                            onChange={(e, val) =>
                              handleSliderChange(e, index, val)
                            }
                            onChangeCommitted={handleChangeComplete}
                            valueLabelDisplay="auto"
                            aria-labelledby="input-slider"
                            disabled={!value.isActive}
                            sx={{
                              mx: 0,
                              color:
                                channelColorMap[value.channelName] ||
                                "primary.main",
                              height: 5,
                              "& .MuiSlider-rail, & .MuiSlider-track": {
                                height: 5,
                              },
                              "& .MuiSlider-thumb": {
                                width: 15,
                                height: 15,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </Box>
                </Grid>
              ))}
          </Grid>
          <Stack direction="row" justifyContent="center" mt={0.75} mb={0}>
            <IconButton
              color="primary"
              onClick={handleAddSlider}
              disabled={
                !roles.includes("edit-spectrum") ||
                !spectrum.some((value) => !value.isActive)
              }
              sx={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                bgcolor: "primary.main",
                color: "primary.contrastText",
                boxShadow: "0 8px 18px rgba(15, 23, 42, 0.18)",
                "&:hover": { bgcolor: "primary.dark" },
                "&.Mui-disabled": {
                  bgcolor: "action.disabledBackground",
                  color: "action.disabled",
                },
              }}
            >
              <AddIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Stack>
          </>
          )}
          <SpdGraph spectrum={spectrum} />
        </Paper>
      </Box>
    </Box>
  );
}
